module.exports = __webpack_public_path__ + "assets/img/help_image03-2@2x.1cff7afa.png";